import ReferralRewardsSection from './ReferralRewardsSection';

export default function RewardsReferralsTab() {
  return (
    <>
      <ReferralRewardsSection />
    </>
  );
}
